import { request } from './client';

/**
 * Tenant API Explorer client. Drives the /tenant/api-explorer page.
 */

export type FieldType = 'string' | 'number' | 'boolean' | 'select' | 'datetime' | 'json' | 'hidden';

export interface ExplorerField {
  name: string;
  label: string;
  type: FieldType;
  required?: boolean;
  advanced?: boolean;
  helperText?: string;
  defaultFromTenant?: string;
  exampleValue?: unknown;
  options?: string[];
  placeholder?: string;
}

export interface ExplorerStep {
  apiCode: string;
  name: string;
  milestone: string;
  category?: string;
  httpMethod: string;
  pathPattern: string;
  sequenceIndex: number;
  description?: string;
  fields: ExplorerField[];
  exampleRequest?: unknown;
  errorDecoder?: Record<string, string>;
  captures?: Record<string, string>;
  fieldSourceHints?: Record<string, string>;
}

export interface ExplorerFlow {
  flowCode: string;
  flowName: string;
  steps: ExplorerStep[];
}

export interface ExplorerCatalog {
  tenantDefaults: Record<string, unknown>;
  flows: ExplorerFlow[];
}

export interface ExplorerRunResult {
  apiCode: string;
  httpStatus: number;
  ok: boolean;
  durationMs: number;
  ranAt: string;
  requestUrl: string;
  requestBody: unknown;
  response: unknown;
  captured: Record<string, unknown>;
  decodedError?: string;
}

export interface IntegrationKit {
  apiCode: string;
  name: string;
  httpMethod: string;
  pathPattern: string;
  description?: string;
  snippets: {
    curl: string;
    javascript: string;
    python: string;
    java: string;
    postman: string;
  };
}

export const explorer = {
  catalog: () =>
    request<ExplorerCatalog>({ url: '/api/abdm/explorer/catalog', method: 'GET' }),
  run: (body: {
    apiCode: string;
    body?: Record<string, unknown>;
    pathParams?: Record<string, unknown>;
    queryParams?: Record<string, unknown>;
    bearerOverride?: string;
  }) =>
    request<ExplorerRunResult>({ url: '/api/abdm/explorer/run', method: 'POST', data: body }),
  integrationKit: (apiCode: string) =>
    request<IntegrationKit>({
      url: `/api/abdm/explorer/integration-kit/${encodeURIComponent(apiCode)}`,
      method: 'GET',
    }),
};
